// export action types
import { CLEAR_USER_SESSION } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { clearUserSession } from 'actions/clearUserSession';
 *
 * // dispatch action
 * store.dispatch( clearUserSession( payload ) );
 */
export const clearUserSession = ( payload ) => {
    return {
        type: CLEAR_USER_SESSION,
        payload: payload
    };
};
